import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { green } from "@mui/material/colors";
import AccountType from "../../../../Utility/Crud/AccountType";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminAccountTypeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "name", name: "Name", type: "string" },
            {
              key: "isMarketing",
              name: "Marketing",
              type: "boolean",
              icon: "Check",
              color: green[500],
              width: "140",
            },
          ]}
          rows={AccountType.sort(
            Object.values(this.context.accountTypesIndexed),
          )}
          onClick={(accountType) => {
            this.props.history.push({
              pathname: "/admin/accountType/" + accountType.id,
            });
          }}
        />
      );
    }
  },
);
